@let mobileView = isMobileView();

<button
  hlmCard
  type="button"
  class="project-card"
  interactive
  [class.project-card--selected]="selected()"
  (click)="projectSelect.emit()"
  [attr.aria-label]="name()"
  [attr.aria-pressed]="selected()"
>
  <div hlmCardContent class="project-card__content">
    <div class="project-card__image-wrapper">
      @if (thumbnail() && !thumbnailError()) {
        <ocp-image
          [src]="thumbnail()!"
          imgClass="project-card__image"
          [alt]="name()"
          [optimized]="true"
          [priority]="true"
          [fill]="true"
          (imageError)="onThumbnailError()"
        />
      } @else {
        <div class="project-card__image-placeholder" aria-hidden="true">
          <ocp-themed-icon name="thumbnail-placeholder.svg" [size]="96" />
        </div>
      }
    </div>

    <div class="project-card__body">
      <div class="project-card__header">
        <span class="project-card__name">{{ name() }}</span>

        @if (teamName()) {
          <div class="project-card__team">
            <ocp-avatar
              [userInitials]="teamInitial()"
              [colorSeed]="teamId()"
              [fontSize]="'var(--font-size-3xs)'"
              size="sm"
              singleInitial
            />
            <span class="project-card__team-name">{{ teamName() }}</span>
          </div>
        }
      </div>

      @if (modelsCount() !== undefined || tasksCount() !== undefined) {
        @if (mobileView) {
          <ng-container *ngTemplateOutlet="statsMobileView" />
        } @else {
          <ng-container *ngTemplateOutlet="statsDesktopView" />
        }
      }
    </div>
  </div>
</button>

<ng-template #statsMobileView>
  <div class="project-card__stats">
    @if (modelsCount() !== undefined) {
      <span class="project-card__stat">
        <ocp-themed-icon size="12px" name="models.svg" />
        {{ modelsCountComputed() }}
      </span>
    }
    @if (tasksCount() !== undefined) {
      <span class="project-card__stat">
        <ocp-themed-icon size="12px" name="tasks.svg" />
        {{ tasksCountComputed() }}
      </span>
    }
  </div>
</ng-template>

<ng-template #statsDesktopView>
  <div class="project-card__stats">
    @if (modelsCount() !== undefined) {
      <span class="project-card__stat">
        {{ modelsCountComputed() }} {{ 'project-card.models' | translate }}
      </span>
    }
    @if (tasksCount() !== undefined) {
      <span class="project-card__stat">
        {{ tasksCountComputed() }} {{ 'project-card.tasks' | translate }}
      </span>
    }
  </div>
</ng-template>
